<ng-template #item let-entry="entry">
  @if (entry.group != null) {
    <span class="me-1">{{ entry.meta.name }}</span>
    <span class="ms-auto badge" [class]="`text-bg-${ColorMapping[entry.meta.level]}`">
      {{ `common.logLevel.${entry.meta.level.toUpperCase()}` | translate }}
    </span>
  } @else {
    <span>{{ entry.label }}</span>
  }
</ng-template>
